module.exports = __webpack_public_path__ + "static/media/PLT_LOGO_WHITE.76185c9a.png";